// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1yc9g","subheader":"ReorderModal_subheader__2poOZ","listWrap":"ReorderModal_listWrap__3YzQd"};